import type {ListMaterialsSearchInput} from "./list-materials.schema";

import {listMaterials} from "@project/sdk/engineering";
import {ListMaterialsResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {materialKeys} from "../../../material-keys";

import {listMaterialsSearchSchema} from "./list-materials.schema";

export function listMaterialsQueryOptions(rawInput: ListMaterialsSearchInput) {
  const params = listMaterialsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: materialKeys.list(params),
    queryFn: async ({signal}) => ListMaterialsResponse.parse(await listMaterials(params, {signal})),
  });
}
